import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseFacade } from '@core/classes/base.facade';
import { TourDto, TourLongDto } from '@api/rest';
import * as fromTour from './_ngrx/tour.reducer';
import * as TourState from './_ngrx/tour.selectors'
import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TourType } from '@app/shared/enums/tour-type.enum';

@Injectable()
export class TourFacade extends BaseFacade {
  private state$: Store<fromTour.State>;


  readonly allTours$: Observable<TourLongDto[]> = this.takeAll(TourState.getTours);
  readonly selectedExhibitionTours$: Observable<TourLongDto[]> = this.takeAll(TourState.getExhibitionTours);
  readonly selected$: Observable<TourDto> = this.takeAll(TourState.getSelected);

  readonly selectedSignal = toSignal(this.selected$);
  readonly allToursSignal = toSignal(this.allTours$);
  readonly profileTourSignal = computed(() => {
    return this.allToursSignal()?.find(tour => tour.type === TourType.PROFILE);
  });

  constructor() {
    const state$ = inject<Store<fromTour.State>>(Store);

    super(state$);

    this.state$ = state$;
  }
}
